import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  
  constructor(private http: HttpClient) { }
  
  getAllSections(params) {
    return this.http.get<any>(`/salary_survey/api/site/faq-section`, {params: params})
      .pipe(map(data => {
        return data;
      }));
  }

  getFaqBySection(section){
    return this.http.get<any>(`/salary_survey/api/site/faq/by-section/${section}`)
      .pipe(map(data => {
        return data;
      }));
  }

  getFaqs(){
    return this.http.get<any>(`/salary_survey/api/site/faq/`)
      .pipe(map(data => {
        return data;
      }));
  }

  getFaqSearch(search){
    return this.http.get<any>(`/salary_survey/api/site/faq/search/${search}`)
      .pipe(map(data => {
        return data;
      }));
  }
}
